import script from "./CardList.vue?vue&type=script&setup=true&lang=js"
export * from "./CardList.vue?vue&type=script&setup=true&lang=js"

import "./CardList.vue?vue&type=style&index=0&id=481fd952&lang=scss"

const __exports__ = script;

export default __exports__